<template>
	<router-view v-if="$route.name == 'PageNotFound' && isSiteStatusCalled"></router-view>
  	<div v-else-if="isSiteStatusCalled">
		<div id="mySidenav" class="sidenav" :class="{ 'nav-left': isSideNav }">
			<div class="close-sidebar-menu"></div>
			<SideMenu @close-side-nav="closeSideNav()" />
		</div>

		<div id="myAcnav" class="sidenav myAcnav" :class="{ 'ac-right': isMobileSideBar }">
			<div class="close-sidebar-menu"></div>
			<div class="sidebar-details">
				<MobileSiderBar @close-mobile-sidebar="closeMobileNav()" @getMyMarketsServiceCall="getMyMarketsServiceCall"/>
			</div>
		</div>

		<div id="body-outer" :class="{ 'nav-body': isSideNav, 'ac-body': isMobileSideBar }">
			<div  @click="isSideNav = false; isMobileSideBar = false"></div>
			<template v-if="!underMaintenance">
				<header v-if="checkForHeaderShow()">
					<Header @open-side-nav="toggleSideNav('side')" @open-mobile-sidebar="toggleMobileSidebar('mobile')" @getMyMarketsServiceCall="getMyMarketsServiceCall"></Header>
				</header>
			</template>

			<main class="main-content"
				:class="$route.name == 'sports-event-detail' && eventDetailHideSections && eventDetailHideSections.includes('show_full_screen') ? 'py-0' : ''">
				<router-view v-if="$siteSettings && $siteSettings.data" />
			</main>
			<footer v-if="!restrictroutes?.includes($route.name) && !underMaintenance">
				<Footer @getMyMarketsServiceCall="getMyMarketsServiceCall"></Footer>
			</footer>

		</div>

	</div>


	<div v-if="successMsg" class="successfully-wrapper show" style="z-index: 9999999999999999;" ref="successmodal"
		id="successfullyModal">
		<SuccessModal :message="successMsg" />
	</div>

	<div v-if="errorMsg" style="z-index: 9999999999999999;" class="successfully-wrapper show" id="wrongtoaster">
		<ErrorModal :message="errorMsg" />
	</div>


	<Offers v-if="$siteSettings?.data?.offer?.image" />
	<AndroidBanneru/>
	<ChangeAndWithdrawPasswordModal :handleUserIdAndOffer="handleUserIdAndOffer"/>
    <UserIdModal/>
	<MyMarket ref="myMarket" />
	<div id="load" v-if="getGlobaLoader() || !isSiteStatusCalled">
		<div id="load-inner"><i class="fa fa-spinner fa-spin"></i></div>
	</div>
</template>

<script>
import { AUTH_TOKEN, getSiteVersion, socketAllEvents, setHeaders } from "@template/utils";
import axios from 'axios';
import { mapGetters } from 'vuex';
import { defineAsyncComponent } from 'vue';
import confetti from "canvas-confetti";
import GamesIframe from '@/shared/components/games/GamesIframe.vue';
import GamePop1 from '@/shared/components/games/GamePop1.vue';
import GamePop2 from '@/shared/components/games/GamePop2.vue';
export default {
  	name: 'App',
	data() {
		return {
			isSideNav: false,
			isMobileSideBar: false,
			onLine: navigator.onLine,
			showBackOnline: false,
			isSiteStatusCalled: false,
			restrictroutes:[
				'virtual-sport',
				'sports-event-detail',
				'matka-details',
				'AffDashboard',
				'AffUsersList',
				'AffProfitLoss',
				'AffStatement',
				'AffReports',
				'wallet-deposit',
				'deposit-payment',
				'wallet-withdraw',
				'Transactions',
				'TransactionDetails',
				'cricketFight',
				'cricketFightDetails',
				'bet-with-team',
				'cricketFightContent',
				'teamBet',
				'Games',
				'multiplayer-games',
				'indian-card-games',
				'fishing-games',
				'slot-games',
				'matka-details',
				'matka',
				'bets',
				'win-loss',
				'WinLossDetail',
				'AffProfitLoss',
				'AffStatement',
				'UserProfitLoss',
				'AffReports',
				'statement',
				'UserProfitLossDetails'
			],
			isApp : false
		}
	},
	computed: {
		...mapGetters(['eventDetailHideSections','successMsg', 'errorMsg', 'siteVersion','siteSettings','underMaintenance','logInData']),
		routePath() {
			return this.$route.name
		},
		domainName() {
			return this.$store.getters.domainName;
		}
	},
	mounted() {
		this.isApp = this.$checkIsApp()
		window.store = this.$store;
		window.cookies = this.$cookies;
		window.router = this.$router;
		if(!this.isApp) this.interval = setInterval(this.checkModalStatus, 60 * 1000);
		window.authorization_token = `Bearer ${this.$cookies.get(AUTH_TOKEN)}`
		setHeaders();  
		if(this.$auth.status) {
			this.$loadCasinoGame.setComponents({
				GamesIframe,
				GamePop1,
				GamePop2,
			})
		}
		window.addEventListener('online', this.updateOnlineStatus);
		window.addEventListener('offline', this.updateOnlineStatus);
		this.$errorToast(null);
		this.$successToast(null);
		socketAllEvents();
		this.getSiteVersion();
	},

	components: {
		Header: defineAsyncComponent(() =>
			import('./shared/components/header/Header.vue')
		),
		SideMenu: defineAsyncComponent(() =>
			import('./shared/components/header/SideMenu.vue')
		),
		Footer: defineAsyncComponent(() =>
				import('./shared/components/footer/Footer.vue')
		),
		MyMarket: defineAsyncComponent(() =>
				import('@/shared/components/modal/MyMarket.vue')
		),
		MobileSiderBar: defineAsyncComponent(() =>
				import('./shared/components/header/MobileSiderBar.vue')
		),
		SuccessModal: defineAsyncComponent(() =>
				import('@/shared/components/modal/SuccessModal.vue')
		),
		ErrorModal: defineAsyncComponent(() =>
				import('@/shared/components/modal/ErrorModal.vue')
		),
		Offers: defineAsyncComponent(() =>
			import('@/shared/components/header/Offers.vue')
		),
		ChangeAndWithdrawPasswordModal: defineAsyncComponent(() =>
			import('@/shared/components/modal/ChangeAndWithdrawPasswordModal.vue')
		),
		UserIdModal: defineAsyncComponent(() =>
			import('@/shared/components/modal/UserIdModal.vue')
		),
		AndroidBanneru :defineAsyncComponent(() =>
			import('@/shared/components/header/AndroidBanneru.vue'))
	},
	methods: {
		getMyMarketsServiceCall(){
           this.$refs.myMarket.getMyMarketsServiceCall('sport')
		},
		toggleMobileSidebar(){
			this.isMobileSideBar = !this.isMobileSideBar;
			if (this.isMobileSideBar) {
				this.isSideNav = false;
				document.body.style.overflow = "hidden";
			}else {
				document.body.style.overflow = ""; 
			}
		},
		toggleSideNav(){
			this.isSideNav = !this.isSideNav;
			if (this.isSideNav) {
				this.isMobileSideBar = false; 
				document.body.style.overflow = "hidden";
			} else {
				document.body.style.overflow = ""; 
			}
		},
		callAnimation(){
			let duration = 1000;
			let end = Date.now() + duration;
			function frame() {
				confetti({
					particleCount: 7,
					angle: 60,
					spread: 55,
					origin: { x: 0 },
				});
				confetti({
					particleCount: 7,
					angle: 120,
					spread: 55,
					origin: { x: 1 },
				});

				if (Date.now() < end) {
					requestAnimationFrame(frame);
				}
			}

			frame(); 
		},
		checkModalStatus() {
			// check if the modal already open
			const modalEl = document?.getElementById('andriodposter');
			const isOpen = modalEl?.classList?.contains('show');
			if(isOpen) return 
			const lastClosed = localStorage.getItem("modalClosedAt");
			const now = Date.now();

			if (!lastClosed || now - lastClosed >= 6 * 60 * 60 * 1000) {
			if(this.$siteSettings?.data?.poster?.filter(s => s?.poster_type == 13)?.length && this.$store?.getters?.androidclose){
          this.$helper.openModal("#andriodposter");
        }
			}
		},
		handleUserIdAndOffer(){
			if(this.logInData?.logInWithMobile){
				if(!this.logInData?.userIds?.includes(this.$auth?.user?.userid ) && !this.$auth.user.isDemo){
					this.showUserId();
				}
				else {
					this.handleOffer();
				}
			}
			else{
				if(!this.logInData?.userIds?.includes(this.$auth?.user?.userid )){
					let newUserIdsList = this.logInData?.userIds || [];
					newUserIdsList.push(this.$auth?.user?.userid)
					let data = {
						"logInWithMobile": this.logInData?.logInWithMobile,
						"userIds": newUserIdsList
					}
					this.$store.dispatch('setLogInData', data);
				}
				this.handleOffer();
			}
		},
		handleOffer(){
			let is_offer = this.$store.getters.is_offer;
			if (this.$auth.status && this.$siteSettings.data.offer != null && is_offer && this.$siteSettings?.data?.business_type == 2) {
				this.$helper.openModal("#offer_pop_up");
			}
		},
		showUserId() {
			this.callAnimation();
            this.$helper.openModal('#userid_Modal');
        },
		getGlobaLoader() {
			return this.$store.getters.globalLoader;
		},
		async getSiteVersion() {
            try {
                let response = await getSiteVersion(this.siteVersion, this.siteSettings, this.isSiteStatusCalled);
                this.isSiteStatusCalled = response.isSiteStatusCalled;
				this.$store.dispatch('setGlobalLoader', false)
                if(response.isMaintenance) {
                    
                    this.$router.push({ name: 'Maintenance' });
                    return;
                };
                if (this.$siteSettings?.data?.languagesList) {
                    this.$setCurrentLangData(this.$siteSettings?.data?.languagesList, this.$siteSettings?.data?.language_code, true, this.$siteSettings?.data?.aws_url)
                }
                if(!this.isApp && this.$siteSettings?.data?.poster?.filter(s => s?.poster_type == 13)?.length && !this.$auth.status && !store?.getters?.androidclose){
					this.$helper.openModal("#andriodposter");
				}
                if (this.$auth.status) {
                    if (!this.$auth?.user?.last_login_at) {
                        this.$helper.openModal("#ChangeAndWithdrawPassword");
                        return;
                    } else {
                        this.handleUserIdAndOffer();
                    }
                }
            } catch (error){
                console.log(error)
                if (error) {
                    this.$errorToast(error[0]);
                }
            };
        },
		refreshAuthToken(refresh = false) {
			this.$apiCall('post', 'AUTH_REFRESH').then(response => {
				let user = this.$store.getters.stateUser;
				user.token = response.data.data.token;
				user.exp = response.data.data.exp;
				this.$cookies.set(AUTH_TOKEN, response.data.data.token);
				this.$store.dispatch('setToken', `Bearer ${response.data.data.token}`);
				window.authorization_token = `Bearer ${this.$cookies.get(AUTH_TOKEN)}`;
				//for add on all APIs
				axios.defaults.headers.common['Authorization'] = `Bearer ${this.$cookies.get(AUTH_TOKEN)}`;
				this.$store.dispatch('setUser', user);
				this.refreshInit = false;
				if (refresh) {
					router.go();
				}
			}).catch(error => {
				if (error) {
					this.$errorToast(error[0]);
				}
				this.refreshInit = false;
			});
		},
		closeSideNav() {
			if (this.isSideNav) {
				this.isSideNav = false;
				document.body.style.overflow = "";
			}
		},	
		closeMobileNav() {
			if (this.isMobileSideBar)
				this.isMobileSideBar = false;
				document.body.style.overflow = "";
		},
		updateOnlineStatus(e) {
			const { type } = e;
			this.onLine = type === 'online';
		},
		checkForHeaderShow() {
			if (this.routePath == 'search') {
				return false;
			} else if (this.eventDetailHideSections && this.eventDetailHideSections.includes('show_full_screen') && this.routePath == 'sports-event-detail') {
				return false;
			} else {
				return true;
			}
		},
	},
	beforeUnmount() {
		if(!this.isApp) clearInterval(this.interval);
	},
	watch: {
		onLine(v) {
			if (v) {
				this.showBackOnline = true;
				setTimeout(() => {
					this.showBackOnline = false;
				}, 1000);
			}
		},
	}
}
</script>
